import { FC } from 'react';

import { useRouter } from '@cvt/routing';

import { CreateMeetingPartial } from '../partials/CreateMeetingPartial';


export const CreateMeeting: FC = () => {
  const router = useRouter();

  return (
    <CreateMeetingPartial onSuccess={meeting => router.meetings.edit(meeting.id).go()}/>
  );
};
